module.exports = __webpack_public_path__ + "img/e-book-psychische-erste-hilfe-mediurs.ac6bb67e.jpg";